import type { ValueLists } from '@ohpen/enso-ui';
import { IntermediaryGetAllResponse, intermediariesSqe, type IntermediariesSqeRequest } from '@pmp/api';
import { useSqeList } from '@pmp/hooks';
import type { SqePage, SqeQuery } from '@pmp/utils';

import { columns, intermediarySqeDefaultSort, intermediarySqeFields } from './tableConfig';

const fetchIntermediariesPage = async (query: SqeQuery): Promise<SqePage<IntermediaryGetAllResponse>> => {
  const { data } = await intermediariesSqe({ body: query as IntermediariesSqeRequest });
  return { items: data.items, total: data.total };
};

export const useIntermediariesSqe = (valueLists?: ValueLists) =>
  useSqeList(fetchIntermediariesPage, columns, intermediarySqeFields, valueLists, intermediarySqeDefaultSort);
